import $ from "jquery";

export function initSinglePage(pageId) {
	const $url = $(`#${pageId}`);
	const $contentContainer = $(`#page-content`);
	const url = $url.data("url");

	window.addEventListener("hashchange", (e) => {
		e.preventDefault();
		onHashChange();
	});

	onHashChange();

	function onHashChange() {
		$contentContainer.addClass("loading");
		$contentContainer.html('<span class="loader">Loading...</span>');
		$.get(url)
			.done((data) => {
				$contentContainer.removeClass("loading");
				$contentContainer.html(data);
			})
			.fail(() => {
				$contentContainer.html("Failed to load page.");
				$contentContainer.removeClass("loading");
			});
	}
}
